import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import { Dialog, Slide, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import FormLogin from '../../components/Login/formLogin';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  bg: {
    background: '#01579b',
  },
  logos: {
    width: '60%',
  },
  bordeBottom: {
    borderBottom: '10px solid #01579b',
  },
}));

const AlertDialogSlideLogin = ({ auth }) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={auth.openAlertDialogSlideLogin}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
        disableBackdropClick={true}
      >
        <DialogTitle id='customized-dialog-title' className={classes.bg}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <img
                src='/img/logo-trenes.png'
                className={classes.logos}
                alt='Ope-ferroviaria'
              />
            </Grid>
            <Grid item xs={6} style={{ textAlign: 'right' }}>
              <img src='/img/logo-min.png' className={classes.logos} alt='logo ' />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className={classes.bordeBottom}>
          <FormLogin />
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(AlertDialogSlideLogin);
